var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let JvQuotaMeter = class JvQuotaMeter extends LitElement {
    constructor() {
        super(...arguments);
        this.used = 0;
        this.total = 300;
    }
    static { this.styles = css `
    :host {
      display: block;
    }
    .track {
      height: 8px;
      border-radius: 999px;
      background: var(--jv-surface-2);
      overflow: hidden;
    }
    .fill {
      height: 100%;
      border-radius: 999px;
      transition: width .4s ease;
    }
    .fill.green { background: #4C9A6A; }
    .fill.yellow { background: #E0A537; }
    .fill.red { background: #D46A5A; }
    .labels {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      font-size: 12px;
      color: var(--jv-ink-2);
    }
    .label-right {
      font-weight: 600;
      color: var(--jv-ink);
    }
  `; }
    get _percent() {
        if (this.total <= 0)
            return 0;
        return Math.min(100, Math.round((this.used / this.total) * 100));
    }
    get _colorClass() {
        const p = this._percent;
        if (p >= 85)
            return 'red';
        if (p >= 60)
            return 'yellow';
        return 'green';
    }
    _formatMinutes(minutes) {
        const hrs = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hrs > 0 && mins > 0)
            return `${hrs}h ${mins}m`;
        if (hrs > 0)
            return `${hrs}h`;
        return `${mins}m`;
    }
    render() {
        const remaining = this.total - this.used;
        const remainingFormatted = remaining > 0 ? this._formatMinutes(remaining) : '0m';
        const usedFormatted = this._formatMinutes(this.used);
        const totalFormatted = this._formatMinutes(this.total);
        return html `
      <div class="track">
        <div class="fill ${this._colorClass}" style="width:${this._percent}%"></div>
      </div>
      <div class="labels">
        <span>${usedFormatted} of ${totalFormatted} used</span>
        <span class="label-right">${remainingFormatted} left</span>
      </div>
    `;
    }
};
__decorate([
    property({ type: Number })
], JvQuotaMeter.prototype, "used", void 0);
__decorate([
    property({ type: Number })
], JvQuotaMeter.prototype, "total", void 0);
JvQuotaMeter = __decorate([
    customElement('jv-quota-meter')
], JvQuotaMeter);
export { JvQuotaMeter };
